export const STORE_CONFIG = Object.freeze({
  brand: "fumvella",
  customerServiceEmail: "change@fumvella.quest",
  operatingRegion: "Hong Kong",
  address: null,
  currency: "USD",
  currencySymbol: "$",
  locale: "en-US",
  timeZone: "Asia/Hong_Kong",
  shippingFee: 9.99,
  paymentPath: "/create_payment.php",
});

export const PAYMENT_RESTRICTED_COUNTRIES = Object.freeze([
  "CU",
  "IR",
  "KP",
  "SY",
]);

export const formatMoney = (amount) =>
  new Intl.NumberFormat(STORE_CONFIG.locale, {
    style: "currency",
    currency: STORE_CONFIG.currency,
    minimumFractionDigits: 2,
  }).format(Number(amount) || 0);

export const storeDate = (date = new Date()) =>
  new Intl.DateTimeFormat(STORE_CONFIG.locale, {
    dateStyle: "long",
    timeZone: STORE_CONFIG.timeZone,
  }).format(date);
